// src/pages/Sent.jsx
import React from 'react';
import { Send, AlertCircle } from 'lucide-react';

export default function Sent() {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <Send className="h-16 w-16 text-gray-400 mb-4" />
            <h2 className="text-xl font-semibold text-gray-700">Sent Folder Not Available</h2>
            <p className="text-gray-500 mt-2 text-center max-w-md">
                Your email server is using POP3 protocol which doesn't support accessing sent emails.
            </p>
            <div className="mt-6 p-4 bg-blue-50 rounded-lg max-w-md">
                <div className="flex items-start">
                    <AlertCircle className="h-5 w-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" />
                    <div className="text-sm text-blue-800">
                        <p className="font-semibold mb-1">Want to access sent emails?</p>
                        <p>Contact your email provider (esolution.lk) and ask if they support IMAP protocol.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}